export enum PeerReviewStatus {
  default = '',
  yes = 'yes',
  no = 'no',
  notApplicable = 'notApplicable',
}
